import React, { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// 🔥 Custom input — behaves like a button (no keyboard)
const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
  <button
    type="button"
    className="form-control text-start example-custom-input"
    onClick={onClick}
    ref={ref}
    style={{
      background: "#fff",
      height: "38px",
      border: "1px solid #ced4da",
      fontSize: "14px"
    }}
  >
    {value || "Select Date"}
  </button>
));
ExampleCustomInput.displayName = "ExampleCustomInput";

// 🔥 Mobile safe wrapper
const MobileSafeDatePicker = ({ value, onChange, placeholder }) => {
  const toDateObj = (iso) => (iso ? new Date(iso) : null);

  return (
    <DatePicker
      selected={toDateObj(value)}
      onChange={(date) => {
        if (date) {
          onChange(date.toISOString().split("T")[0]);
        } else {
          onChange("");
        }
      }}
      dateFormat="dd-MM-yyyy"
      placeholderText={placeholder}

      // ⭐ NO KEYBOARD, because it's a button, not an input
      customInput={<ExampleCustomInput />}

      // ⭐ No Popper conflicts
      withPortal
      portalId="root-portal"
      shouldCloseOnSelect={true}
    />
  );
};

export default MobileSafeDatePicker;



